export const FLAG_MESSAGE_DURATION = 4000;
